






































import { Component } from "vue-property-decorator";
import FscSimpleCard from "@/components/Card/FscSimpleCard.vue";
import Actions from "@/components/Actions.vue";
import CreateButton from "@/components/Button/CreateButton.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Table from "@/components/Table.vue";
import { namespace } from "vuex-class";
import StudentCategoriesCreate from "@/views/Configuration/StudentCategories/StudentCategoriesCreate.vue";
import StudentCategoriesEdit from "@/views/Configuration/StudentCategories/StudentCategoriesEdit.vue";
import { mixins } from "vue-class-component";
import CompanyMixin from "@/mixins/CompanyMixin";
import { IStudentCategory } from "@/interfaces/IStudentCategory";

const StudentCategoriesModule = namespace("student-categories");

@Component({
  components: {
    FscSimpleCard,
    Actions,
    CreateButton,
    EditButton,
    Table,
    StudentCategoriesCreate,
    StudentCategoriesEdit,
  },
})
export default class StudentCategories extends mixins(CompanyMixin) {
  public name = "StudentCategories";

  @StudentCategoriesModule.Action("findAllCategories")
  public findAllCategories: any;

  @StudentCategoriesModule.Getter("getDataList")
  public studentCategories!: Array<IStudentCategory>;

  @StudentCategoriesModule.Getter("getIsLoading")
  public isLoading!: boolean;

  @StudentCategoriesModule.Action("createCategory")
  public createStudentCategory: any;

  @StudentCategoriesModule.Getter("getSuccess")
  public studentCategoriesSuccess!: any;

  @StudentCategoriesModule.Action("updateCategory")
  public updateStudentCategory: any;

  @StudentCategoriesModule.Action("archiveStudentCategory")
  public archiveStudentCategory: any;

  public get fields() {
    return [
      {
        label: this.$t("student_category.category_name"),
        key: "name",
      },
      {
        label: this.$t("student_category.category_abbreviation"),
        key: "abbreviation",
      },
      {
        label: this.$tc("general.archived", 1),
        key: "archived",
      },
    ];
  }

  public visibleCreateForm = false;
  public visibleEditForm = false;

  public selectedCategory: IStudentCategory | null = null;

  public async mounted(): Promise<void> {
    await this.findAllCategories();
  }

  public get sortedStudentCategories(): IStudentCategory[] {
    return [...this.studentCategories].sort((a, b) => a.id - b.id);
  }

  public onStudentCategoryRowClicked(category: IStudentCategory): void {
    this.selectedCategory = category;
  }

  public async studentCategoryCreateSubmit(category: IStudentCategory): Promise<void> {
    await this.createStudentCategory(category);

    if (this.studentCategoriesSuccess) {
      await this.findAllCategories();
      this.closeCreateEditForm();
    }
  }

  public async studentCategoryUpdateSubmit(category: IStudentCategory): Promise<void> {
    category.id = this.selectedCategory?.id;

    if (this.studentCategoriesSuccess) {
      await this.updateStudentCategory(category);
      this.closeCreateEditForm();
    }
  }

  public openCreateForm(): void {
    this.visibleCreateForm = true;
    this.visibleEditForm = false;
  }

  public closeCreateEditForm(): void {
    this.visibleCreateForm = false;
    this.visibleEditForm = false;
  }

  public openEditForm(): void {
    if (this.selectedCategory) {
      this.visibleEditForm = true;
      this.visibleCreateForm = false;
    }
    return;
  }

  public async onCheckBoxChange(checkBox: any): Promise<void> {
    const options = {
      id: checkBox.id,
      archived: checkBox.archived,
    };
    await this.archiveStudentCategory(options);
  }
}
